module.exports = __webpack_public_path__ + "img/QA.96d5d5c6.png";